import { useMemo } from 'react';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import LessonOverview from './LessonOverview';
import ProfessorList from './ProfessorList';
import ResourcesList from './ResourcesList';
import UsageTracker from '../../utils/UsageTracker';
import { isVideoAsset } from '../../features/tracks/tracksUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LessonInfoTabs = ({
  content,
  hubId,
  lesson,
  onResourceClick
}) => {
  var _ref, _content$hubId;
  const {
    isTablet,
    isMobile
  } = useMediaQuery();
  const onTabChange = event => UsageTracker.trackStandalone('Learning Center Interaction', {
    action: 'lesson-info-tab-clicked',
    tab: event.target.value
  });
  const handleOrganisationUrlClick = (professorId, organisation, organisationUrl) => () => UsageTracker.trackStandalone('Learning Center Interaction', {
    action: 'professor-organisation-click',
    contentType: 'LESSON',
    appearsIn: 'lessons',
    organisation,
    organisationUrl,
    professorId,
    lessonId: lesson.id,
    contentId: content === null || content === void 0 ? void 0 : content.id
  });
  const {
    additionalResources,
    professors
  } = useMemo(() => {
    const instructors = lesson.content.reduce((acc, curr) => {
      if (isVideoAsset(curr)) {
        curr.professors.forEach(p => {
          acc[p.id] = p;
        });
      }
      return acc;
    }, {});
    const learningMaterials = lesson.learningMaterials.map(lm => ({
      type: readUnhandledEnumCase(lm.type),
      title: lm.title,
      targetUrl: lm.targetUrl
    }));
    return {
      additionalResources: learningMaterials,
      professors: Object.values(instructors)
    };
  }, [lesson]);
  return /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsxs(Tabs, {
      defaultSelected: "lesson-info",
      fill: true,
      inlineSize: isMobile ? '100%' : undefined,
      onSelectedChange: onTabChange,
      children: [/*#__PURE__*/_jsx(Tab, {
        padding: isTablet ? '250' : undefined,
        tabId: "lesson-info",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.aboutThisLesson"
        }),
        children: /*#__PURE__*/_jsx(View, {
          padding: "200",
          children: /*#__PURE__*/_jsx(LessonOverview, {
            description: lesson.description,
            hubId: (_ref = (_content$hubId = content === null || content === void 0 ? void 0 : content.hubId) !== null && _content$hubId !== void 0 ? _content$hubId : lesson.hubId) !== null && _ref !== void 0 ? _ref : hubId,
            visibility: lesson.visibility
          })
        })
      }), professors.length > 0 && /*#__PURE__*/_jsx(Tab, {
        padding: isTablet ? '250' : undefined,
        tabId: "lesson-professors",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.lessonInformation.professors",
          options: {
            count: professors.length
          }
        }),
        children: /*#__PURE__*/_jsx(View, {
          padding: "200",
          children: /*#__PURE__*/_jsx(ProfessorList, {
            handleOrganisationUrlClick: handleOrganisationUrlClick,
            i18nHeading: "learningCenter.lessonInformation.professors",
            professors: professors
          })
        })
      }), /*#__PURE__*/_jsx(Tab, {
        padding: isTablet ? '250' : undefined,
        tabId: "resources",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.resources.title"
        }),
        children: /*#__PURE__*/_jsx(View, {
          padding: "200",
          children: /*#__PURE__*/_jsx(ResourcesList, {
            additionalResources: additionalResources,
            i18nHeading: "learningCenter.lessonResources",
            i18nNoResources: "learningCenter.noLessonResources",
            onResourceClick: onResourceClick,
            slidesUrl: lesson.slidesUrl || undefined,
            transcriptUrl: lesson.transcriptUrl || undefined
          })
        })
      })]
    })
  });
};
export default LessonInfoTabs;